import { Link } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import Newsletter from './components/Newsletter';
import { articles } from '@/mocks/articles';

export default function Home() {
  const recentArticles = articles.slice(0, 6);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '第一次的人妻',
            url: 'https://diyiciderenqi.com/',
            description: '专为初为人妻的女性提供实用建议，涵盖婚后角色转变、家庭经营、夫妻沟通与自我成长',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://diyiciderenqi.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '第一次的人妻',
            url: 'https://diyiciderenqi.com/',
            description: '专为初为人妻的女性提供实用建议的新婚生活指南平台',
          }),
        }}
      />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />

        <section className="py-14 md:py-20 bg-background-50" data-product-shop>
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
                最新文章
              </h2>
              <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
                持续更新的实用内容，陪伴你的婚姻成长每一步
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {recentArticles.map((article) => (
                <article
                  key={article.id}
                  className="group bg-white rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <Link to={`/article/${article.slug}`} className="block">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="px-2.5 py-1 text-xs rounded-full bg-secondary-100 text-secondary-700 font-medium">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-500">{article.date}</span>
                    </div>
                    <h3 className="text-base md:text-lg font-heading font-medium text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-3 text-xs text-foreground-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i> {article.readTime}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-user-line"></i> {article.author}
                      </span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>

            <div className="text-center mt-10">
              <Link
                to="/category/role-transition"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-primary-500 text-primary-500 font-medium text-sm hover:bg-primary-500 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                浏览全部文章 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        <Newsletter />
      </main>
    </>
  );
}